import { lazy } from "react";


// constants.js
export const APP_LOGO = "https://apis.metabuddy.app/apis/storage/assets/uploads/socbuddy_logo.png";
export const LOGGED_IN_USER_DATA = "loggedin_user_data";
export const CURRENT_ORG = "current_org";
export const CURRENT_ORG_IDENTIFIER = "current_org_identifier";


